<template>
  <div class="table-card">
    <table class="results-table">
      <thead>
        <th></th>
        <th v-for="column in columns" :key="column.id">
          <div class="column-title">{{ column.title }}</div>
        </th>
      </thead>
      <tbody>
        <tr v-for="(cells, label) in rows" :key="label">
          <td class="date">{{ dateLabel(label) }}</td>
          <td v-for="column in columns" :key="column.id">
            <div v-if="!cells[column.id]">-</div>
            <div v-else>
              <div class="number">{{ cells[column.id] }}</div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ReaderTable",
  data: function() {
    return {
      columns: [
        { id: "totalReviews", title: "Reviews Completed" },
        { id: "totalPoints", title: "Snaps Earned" },
        { id: "avgTurnaround", title: "Avg. Turnaround" }
      ]
      //   rows: {
      //     "April 2019": [[1, 4.2], [4, 4.7]],
      //     "March 2019": [[2, 4.3], [5, 4.8]],
      //     "February 2019": [[3, 4.4], [6, 4.9]],
      //     "January 2019": [[3, 4.4], [6, 4.9]],
      //     "December 2018": [[3, 4.4], [6, 4.9]]
      //   }
    };
  },
  computed: {
    rows() {
      if (!this.user) {
        return null;
      }

      // console.log("rows", this.user.readerStats.history_table);
      return this.user.readerStats.history_table;
    },
    ...mapState({
      user: "user"
    })
  },
  methods: {
    dateLabel(label) {
      const year = new Date().getFullYear();
      return label.replace(" " + year, "");
    }
  }
};
</script>

<style lang="scss" scoped>
.table-card {
  float: left;
  box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
  border-radius: 8px;
  padding: 0px;
}

.results-table {
  font-family: $font-family;
  border-spacing: 0 !important;

  .column-title {
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0.5em 0 0 0;
    color: #777;
    font-weight: 600;
    text-align: center;
  }

  thead {
  }

  th {
    width: 200px;
    border-right: 1px solid #e9e9e9;
    border-bottom: 3px solid #e9e9e9;
    padding: 0.5em 1em;
    font-size: 13.5pt;
    font-weight: 700;
  }

  th:first-child {
    width: 200px;
    border-right: 1px solid #e9e9e9;
  }
  th:last-child {
    border-right: 0;
  }

  tr {
  }

  td {
    min-width: 160px;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9 !important;
    padding: 0.5em;
    text-align: center;
    font-size: 13.5pt;
    font-weight: 600;
  }
  td:first-child {
    border-right: 1px solid #e9e9e9;
  }
  td:last-child {
    border-right: 0;
  }

  .date {
    text-align: center;
    padding-right: 0em;
    font-weight: 500;
  }

  .number {
    margin-top: 4px;
  }

  .review-count {
    float: left;
    width: 50%;
    margin-top: 4px;
  }
  .avg-rating {
    float: left;
    width: 50%;
    margin-top: 4px;
  }
}

.avg-rating-icon {
  float: left;
  margin-top: 4px;
}
.avg-rating-number {
  float: left;
  margin-left: 6px;
  font-weight: 400;
}
.icon-trend {
  margin-left: 0px;
  margin-top: 0px;
  width: 20px;
  color: #ff5722;
}

.column-cover-img {
  width: 36px;
}
</style>


